import "../styles/contact.scss";
import "../styles/contact_mobile.scss";
import CloseIcon from '@material-ui/icons/Close';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PublicIcon from '@material-ui/icons/Public';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import CallIcon from '@material-ui/icons/Call';
import ListIcon from '@material-ui/icons/List';
const Contact=({click})=>{
    return(
        <div className="contact">
            
           

           
			
			
			
			<div className="m-2 mb-2">
			<label className="text-sm font-semibold">Nom & Prénom</label>
			<div className="flex items-center bg-white p-1 rounded-sm">
				<input type="text" className="text-sm bg-transparent outline-none flex-1 " />
				<AssignmentIndIcon style={{fontSize:20}} />
			</div>
		</div>
		
		<div className="m-2 mb-2">
			<label className="text-sm font-semibold">Email</label>
			<div className="flex items-center bg-white p-1 rounded-sm">
				<input type="text" className="text-sm bg-transparent outline-none flex-1 " />
				<MailOutlineIcon style={{fontSize:20}} />
			</div>
		</div>
		
		
		
		
		
		
		<div className="m-2 mb-2">
			<label className="text-sm font-semibold">Téléphone</label>
			<div className="flex items-center bg-white p-1 rounded-sm">
				<input type="text" className="text-sm bg-transparent outline-none flex-1 " />
				<CallIcon style={{fontSize:20}} />
			</div>
		</div>
		
		<div className="m-2 mb-2">
			<label className="text-sm font-semibold">Message</label>
			<div className="flex items-center bg-white p-1 rounded-sm">
				<textarea type="text" className="text-sm bg-transparent outline-none flex-1 " />
				
			</div>
		</div>
		
		<div className="m-2 flex items-center justify-center">
			<button className="bg-white p-2 pl-4 pr-4 text-sm rounded-md cursor-pointer hover:opacity-50" onClick={click}>Soumettre</button>
		</div>

            {/*<iframe src="https://docs.google.com/forms/d/e/1FAIpQLSeF7gsJEOvAbQDIFcM8zwlwi5lXLnRJ7H0BC1P3sJ62nRTbVA/viewform?embedded=true" width="250" height="1334" frameborder="0" marginheight="0" marginwidth="0" scrolling="no">Chargement…</iframe>*/}

        </div>
    );
}
export default Contact;